"use client";

import { c as _c } from "react/compiler-runtime";
export function ChatTypingIndicator() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="flex justify-start"><div className="rounded-2xl rounded-bl-sm bg-secondary px-4 py-3"><div className="flex gap-1"><span className="h-2 w-2 animate-bounce rounded-full bg-muted-foreground [animation-delay:0ms]" /><span className="h-2 w-2 animate-bounce rounded-full bg-muted-foreground [animation-delay:150ms]" /><span className="h-2 w-2 animate-bounce rounded-full bg-muted-foreground [animation-delay:300ms]" /></div></div></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}